const features = [
  {
    icon: 'ri-4k-line',
    title: '超清画质',
    desc: '支持1080P超清播放，画面细腻逼真，每一个细节都清晰可见，还原影院级观影体验。',
  },
  {
    icon: 'ri-speed-up-line',
    title: '极速加载',
    desc: '采用智能CDN加速与P2P传输技术，告别缓冲等待，点击即播，流畅到底。',
  },
  {
    icon: 'ri-stack-line',
    title: '海量片库',
    desc: '收录20000+高清电影与高清电视剧，涵盖动作、科幻、悬疑、古装等多种类型。',
  },
  {
    icon: 'ri-device-line',
    title: '多端同步',
    desc: '支持电脑、平板、手机全终端访问，观影记录云端同步，随时随地继续观看。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-16 md:py-20 bg-background-100">
      <div className="mx-auto max-w-[1440px] px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-accent-100 text-accent-700 mb-3 whitespace-nowrap">
            为什么选择我们
          </span>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
            核心优势
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            四大核心能力，重新定义你的在线观影标准
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {features.map((f, i) => (
            <div
              key={i}
              className="group bg-background-50 rounded-xl p-6 md:p-7 border border-background-200/50 transition-all hover:-translate-y-1"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-100 text-primary-600 mb-5 group-hover:bg-primary-500 group-hover:text-white transition-all">
                <i className={`${f.icon} text-xl`}></i>
              </div>
              <h3 className="text-lg font-bold text-foreground-900 mb-2">{f.title}</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}